import React from "react";

import PrimaryButton from "../../../../../../../components/buttons/PrimaryButton";

interface IProps {
  isLoading: boolean;
}

const FormButtons = ({ isLoading }: IProps) => {
  return (
    <div className="mt-4 mb-4 flex flex-row">
      <PrimaryButton
        loading={isLoading}
        title={"Crear"}
        className={
          "bg-buttonBlack text-whiteSoft mt-5 rounded-3xl px-5 py-1 text-sm font-normal"
        }
        type="submit"
      />
    </div>
  );
};

export default FormButtons;
